// Supabase JS client — singleton.
// Used for phone OTP auth and session state. All database reads/writes still
// go through Netlify functions (postgres.js / DATABASE_URL); we never use the
// Supabase data API from the client.

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  // Fail loud in dev; in prod this would mean a broken build env.
  // eslint-disable-next-line no-console
  console.error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY')
}

// detectSessionInUrl MUST be true for the OAuth (Google/Facebook) sign-in
// added for social profile pictures: the provider redirect returns the auth
// code/tokens in the return URL, and Supabase only parses + exchanges them
// (establishing the session and firing onAuthStateChange SIGNED_IN) when this
// is on. For the phone-OTP flow it is a no-op — an OTP verify never returns
// tokens in the URL — so flipping it does not disturb the phone path, the
// auth-resume fix (#239), or the boot/signup gates: those all key off
// getSession()/onAuthStateChange, which run identically. flowType stays the
// SDK default (PKCE), which round-trips a `?code=` param cleanly.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
